var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTableSmall = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2001_8201)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.853638,
    y: 4.55957,
    width: 12,
    height: 10.5656,
    transform: "rotate(-15 0.853638 4.55957)",
    stroke: "#838C91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.855042,
    y: 4.56445,
    width: 12,
    height: 3.37652,
    transform: "rotate(-15 0.855042 4.56445)",
    stroke: "#838C91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.64728,
    y: 11.2535,
    width: 12,
    height: 3.63544,
    transform: "rotate(-15 2.64728 11.2535)",
    stroke: "#838C91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.72864,
    y: 7.82568,
    width: 4,
    height: 7.18424,
    transform: "rotate(-15 1.72864 7.82568)",
    stroke: "#838C91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.45764,
    y: 5.76038,
    width: 4,
    height: 7.17873,
    transform: "rotate(-15 9.45764 5.76038)",
    stroke: "#838C91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2001_8201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTableSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/table_small.3a186d17064215c0b314bd12ebde9b70.svg";